require("../cookie.cjs");
//#region src/lib/getPreviewCookie.ts
const readValue = (value) => {
	return value.replace(/%3B/g, ";");
};
/**
* Returns the value of a cookie from a given cookie store.
*
* @param cookieJar - The stringified cookie store from which to read the cookie.
* @returns The value of the cookie, if it exists.
*/
const getPreviewCookie = (cookieJar) => {
	const cookies = cookieJar.split("; ");
	let value;
	for (const cookie of cookies) {
		const parts = cookie.split("=");
		if (readValue(parts[0]).replace(/%3D/g, "=") === "io.prismic.preview") {
			value = readValue(parts.slice(1).join("="));
			break;
		}
	}
	return value;
};
//#endregion
exports.getPreviewCookie = getPreviewCookie;

//# sourceMappingURL=getPreviewCookie.cjs.map